import { Task } from "./task";
import { Identifiable } from "./identifiable";
import { List } from "./list";
import { Project } from "./project";

type PersonalSynthesis = {
  overDueTasks: (Identifiable<Task> & {
    list: Identifiable<List> & {
      project: Identifiable<Project>;
    };
  })[];
  upComingTasks: (Identifiable<Task> & {
    list: Identifiable<List> & {
      project: Identifiable<Project>;
    };
  })[];
  delayedTasksNbr: number;
  openedTasksNbr: number;
  completedTasksNbr: number;
  allocatedTasksNbr: number;
};

const personalSynthesis: PersonalSynthesis = {
  upComingTasks: [],
  overDueTasks: [],
  delayedTasksNbr: 0,
  openedTasksNbr: 0,
  completedTasksNbr: 0,
  allocatedTasksNbr: 0,
};

export type { PersonalSynthesis };

export { personalSynthesis };
